import Vue from 'vue'
import Router from 'vue-router'
import InstallAtion from '@/pages/installation'
import Introduction from '@/pages/introduction'
import Started from '@/pages/started'
import Basic from '@/pages/layou/basic'
import abreast from '@/pages/layou/abreast'
import Responsive from '@/pages/layou/responsive'
import Concepts from '@/pages/layer/concepts'
import Frist from '@/pages/layer/frist'
import More from '@/pages/layer/more'
import Type from '@/pages/layer/type'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'introduction',
      component: Introduction
    },
    {
      path: '/installation',
      name: 'installation',
      component: InstallAtion
    },
    {
      path: '/started',
      name: 'started',
      component: Started
    },
    {
      path: '/layou/basic',
      name: 'basic',
      component: Basic
    },
    {
      path: '/layou/abreast',
      name: 'abreast',
      component: abreast
    },
    {
      path: '/layou/responsive',
      name: 'responsive',
      component: Responsive
    },
    {
      path: '/layer/concepts',
      name: 'concepts',
      component: Concepts
    },
    {
      path: '/layer/frist',
      name: 'frist',
      component: Frist
    },
    {
      path: '/layer/more',
      name: 'more',
      component: More
    },
    {
      path: '/layer/type',
      name: 'type',
      component: Type
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js